<template>
  <div class="descriptions__searchInput">
    <img src="../../../assets/images/search.svg" alt="search" />
    <input
      type="text"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    placeholder: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: true
    }
  }
}
</script>
